module.exports = __webpack_public_path__ + "static/img/img02.30aa043.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv011/img02.gif
// module id = y89q
// module chunks = 0